import MainMenu from '@/components/foundation/main-menu/MainMenu'
import ItemQuote from '@/view/item-quote/ItemQuote'
import store from '../../state'

export const ItemQuoteRoute = {
  path: '/item-quote/:id',
  name: 'ItemQuote',
  components: {
    default: ItemQuote,
    mainMenu: MainMenu
  },
  async beforeEnter (to, from, next) {
    const eventInfo = await store.dispatch('Board/GET_EVENT_DETAILS', {
      eventId: to.params.id
    })
    const eventDetail = { ...eventInfo }
    store.commit('Events/SET_EVENT_INFO', { eventDetail })
    next()
  },
  meta: {
    auth: true,
    mainArea: 'event',
    area: 'event',
    breadcrumb: [
      {
        name: 'Evento',
        link: '/event'
      },
      {
        eventCode: 'Events/EVENT_CODE',
        isOpenClose: 'Events/IS_OPEN_CLOSE',
        clientName: 'Events/CLIENT_NAME',
        eventIdentification: 'Events/EVENT_IDENTIFICATION',
        linkGetter: 'Events/GET_EVENT_LINK'
      },
      {
        name: 'Cotação de Items'
      }
    ]
  }
}



// WEBPACK FOOTER //
// ./src/router/item-quote/ItemQuoteRoute.js